import axios from 'axios';

export function requestPages(vuexContext) {
	axios.get('/wp-json/wp/v2/pages')
		.then((response) => {
			vuexContext.commit('setPages', response.data);
		})
		.catch(e => {
			throw e;
		});
}

// step 3 from state.action
// export function requestProducts(vuexContext) {
// 	axios.get('/wp-json/sapphire-bath/v2/get_products_ax')
// 		.then((response) => {
// 			// step 3b - set data to state mutation
// 			vuexContext.commit('setProducts', response.data);
// 		})
// 		.catch(e => {
// 			throw e;
// 		});
// }


// export function requestCountProducts(vuexContext) {
// 	axios.get('/wp-json/sapphire-bath/v2/get_count_products')
// 		.then((response) => {
// 			vuexContext.commit('setCountProducts', response.data);
// 		})
// 		.catch(e => {
// 			throw e;
// 		});
// }
//
// export function requestProductsType(vuexContext) {
// 	axios.get('/wp-json/sapphire-bath/v2/get_products_type_ax')
// 		.then((response) => {
// 			vuexContext.commit('setProductsType', response.data);
// 		})
// 		.catch(e => {
// 			throw e;
// 		});
// }
//
// export function requestProductCollections(vuexContext) {
// 	axios.get('/wp-json/sapphire-bath/v2/get_product_collections_ax')
// 		.then((response) => {
// 			vuexContext.commit('setProductCollections', response.data);
// 		})
// 		.catch(e => {
// 			throw e;
// 		});
// }
